// Popular slider
new Splide( '#hero',{
    //padding: '2rem',
    trimSpace: false,
    perPage: 1,
    perMove: 1,
    pagination: false,
    arrows: false,
    rewind: true,
    autoplay: 'playing',
    type: 'fade',
    //direction   : 'ttb',
    arrowPath: 'M0 7.00008V9.00008H12L6.5 14.5001L7.92 15.9201L15.84 8.00008L7.92 0.0800781L6.5 1.50008L12 7.00008H0Z',

    breakpoints: {
        1280: {
            perPage: 1,
        },
        860: {
            perPage: 1,
        },
        580: {
            perPage: 1,
        },
    },

    classes: {
    },
} ).mount();


document.addEventListener('DOMContentLoaded', function() {
    var video = document.getElementById('video-wrapper');
    video.style.opacity = '0'; // Set initial opacity to 0
    setTimeout(function() {
        video.style.opacity = '1'; // Fade in after 1 second
    }, 1000); // Delay of 1 second (1000 milliseconds)
});
